import Avatar from 'boring-avatars';

const prefixes = ['marble', 'beam', 'bauhaus'] as const;
type Variant = typeof prefixes[number];

type AvatarDisplayProps = {
  avatar: string;
  size?: number;
};

export default function AvatarDisplay({ avatar, size = 80 }: AvatarDisplayProps) {
  const [variant, ...rest] = avatar?.split('-') ?? ['beam'];
  const isValidVariant = (prefixes as readonly string[]).includes(variant);
  const finalVariant = isValidVariant ? (variant as Variant) : 'beam';

  return (
    <div className="avatar">
        <Avatar
        name={avatar || 'default-avatar'}
        colors={["#FFB400", "#00A6ED", "#F6511D", "#0C0908", "#f1eeedff"]}
        variant={finalVariant}
        size={size}
        />
    </div>
  );
}
